import { useEffect, useState } from 'react';
import { MdAccessTime } from 'react-icons/md';
import styles from './SessionTimeoutModal.module.css';

const COUNTDOWN_S = 60;

function SessionTimeoutModal({ onContinue, onLogout }) {
  const [seconds, setSeconds] = useState(COUNTDOWN_S);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) { clearInterval(interval); onLogout(); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [onLogout]);

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        <div className={styles.iconRing}>
          <MdAccessTime size={26} />
        </div>
        <h2 className={styles.title}>Still there?</h2>
        <p className={styles.body}>
          You've been inactive for 30 minutes.<br />
          You'll be signed out automatically in
        </p>
        <div className={`${styles.countdown} ${seconds <= 10 ? styles.urgent : ''}`}>
          {seconds}s
        </div>
        <div className={styles.actions}>
          <button className={styles.btnLogout} onClick={onLogout}>Sign out</button>
          <button className={styles.btnContinue} onClick={onContinue}>Continue session</button>
        </div>
      </div>
    </div>
  );
}

export default SessionTimeoutModal;
